export default __webpack_public_path__ + "static/media/No-address.80466351.svg";